import React, { useState, useRef } from "react";
import { useChatStore } from "../../services/ChatStore";
import {
  Box,
  TextField,
  IconButton,
  Paper,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloseIcon from "@mui/icons-material/Close";

export default function ChatInput() {
  const [text, setText] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const { sendMessage, isLoading } = useChatStore();

  const handleSend = () => {
    if (isLoading || (!text.trim() && !imageFile)) return;
    sendMessage(text, imageFile);
    // Очистка
    setText("");
    setImageFile(null);
    setImagePreview(null);
  };

  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
    // Очищаем value инпута, чтобы можно было выбрать тот же файл снова
    e.target.value = null;
  };

  const removeImage = () => {
    setImageFile(null);
    setImagePreview(null);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 1,
        display: "flex",
        flexDirection: "column",
        borderRadius: "16px",
      }}>
      {/* --- 1. ПРЕВЬЮ ИЗОБРАЖЕНИЯ (появляется сверху) --- */}
      {imagePreview && (
        <Box sx={{ p: 1, position: "relative", width: "fit-content" }}>
          <Box
            component="img"
            src={imagePreview}
            alt="Preview"
            sx={{
              maxHeight: "100px",
              width: "auto",
              borderRadius: 1.5,
              border: "1px solid",
              borderColor: "divider",
            }}
          />
          <IconButton
            size="small"
            onClick={removeImage}
            sx={{
              position: "absolute",
              top: -10,
              right: -10,
              bgcolor: "background.paper",
              "&:hover": { bgcolor: "grey.200" },
            }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      )}

      {/* --- 2. ПОЛЕ ВВОДА И КНОПКИ --- */}
      <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
        {/* Кнопка "Прикрепить файл" */}
        <Tooltip title="Прикрепить изображение">
          <IconButton
            color="primary"
            onClick={() => fileInputRef.current.click()}
            disabled={isLoading}>
            <AttachFileIcon />
          </IconButton>
        </Tooltip>
        {/* Скрытый input для файлов */}
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          accept="image/*"
          style={{ display: "none" }}
        />

        {/* Поле ввода текста */}
        <TextField
          variant="standard"
          fullWidth
          multiline
          maxRows={5}
          value={text}
          disabled={isLoading}
          onChange={e => setText(e.target.value)}
          onKeyDown={e => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
          placeholder="Напишите ваш вопрос..."
          InputProps={{
            disableUnderline: true,
            sx: { fontSize: "0.95rem", p: 1 },
          }}
        />

        {/* Кнопка "Отправить" */}
        <Tooltip title="Отправить">
          <IconButton
            color="primary"
            onClick={handleSend}
            disabled={isLoading || (!text.trim() && !imageFile)}
            sx={{
              bgcolor: "primary.main",
              color: "white",
              "&:hover": { bgcolor: "primary.dark" },
              "&.Mui-disabled": { bgcolor: "action.disabled" },
            }}>
            {isLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <SendIcon fontSize="small" />
            )}
          </IconButton>
        </Tooltip>
      </Box>
    </Paper>
  );
}
